<template>
<transition @leave="leave">
  <a-entity>
    <a-entity ref="object" look-at=".Camera" position="0 0 -1">
      <a-image
        v-if="this.$route.meta.name == 'wait'"
        :src="cdn(require('./img/text-intro-' + type + lang + '.png'))"
        @materialtextureloaded="textEnter"
        height="1.1" width="1.1"
        material="shader: flat; depthTest: false"
        transparent="true"
        opacity="0"
        ref="text"
      >
        <a-image
          class="Fuse"
          :src="cdn(require('./img/text-intro-btn-' + lang + '.png'))"
          @materialtextureloaded="btnEnter"
          height=".11" width=".11"
          ref="btn"
          opacity="0"
          scale="0 0 0"
          transparent="true"
          material="shader: flat; depthTest: false"
          @click="$router.push({ name: 'start.' + lang })"
        />
      </a-image>
    </a-entity>
  </a-entity>
</transition>
</template>

<script>
export default {
  name: 'Wait',
  data: () => ({
    type: '',
    checkPos: [
      {
        ref: 'object',
        desktop: { scale: 1 },
        mobile: { scale: .6 },
        landscape: { scale: .8 }
      },
      {
        ref: 'btn',
        desktop: { x: .37, y: -.3 },
        mobile: { y: -.6 },
        landscape: { y: -.3 }
      }
    ]
  }),
  watch: {
    orientation: 'setType'
  },
  created() {
    this.setType()
  },
  methods: {
    setType() {
      this.type = this.$root.$agent.mobile && this.orientation == 'portrait' ? 'mobile-' : ''
      if(this.vr)
        this.type = ''
    },
    textEnter() {
      this.setDyniquePos()
      TweenLite.set(this.$el, { aframe: { rotationY: THREE.Math.radToDeg(this.$parent.$refs.camera.object3D.rotation.y) }  })
      TweenLite.to(this.$refs.text, 1, { delay: 1, aframe: { alpha: 1 } })
    },
    btnEnter() {
      TweenLite.to(this.$refs.btn, 1, { delay: 1, aframe: { alpha: 1, scale: this.$root.$agent.mobile ? 1.5 : 1 } })
    },
    leave(el, done) {
      TweenMax.to([this.$refs.text, this.$refs.btn], 1, { aframe: { alpha: 0 }, onComplete: done})
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/wait/Wait.vue